"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  site: 'bbcgoodfood',
  posts: {
    userRecipe: {
      disclaimer: [{
        type: 'html',
        data: {
          value: 'Member recipes are not tested in the GoodFood kitchen.'
        }
      }]
    }
  },
  social: {
    rssFeed: '/feed/atom',
    twitterHandle: '@bbcgoodfood',
    facebookProfile: 'BBCGoodFood',
    youtubeChannel: 'UCl4i6QsatTho9QJW50GbLAA',
    instagramProfile: 'bbcgoodfood'
  },
  header: {
    logo: 'primary',
    eyebrowLogo: 'secondary',
    eyebrowColour: 'dark'
  },
  siteIdentity: {
    logo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/30/2019/07/GoodFood-dark-516d417.png',
      alt: 'The BBC Good Food logo',
      width: 221,
      height: 58
    },
    secondaryLogo: {
      url: 'https://images.immediate.co.uk/production/volatile/sites/30/2019/07/GoodFood-light-4f4a032.png',
      alt: 'The BBC Good Food logo',
      width: 221,
      height: 58
    }
  },
  siteConfig: {
    search: {
      placeholder: 'Ingredient, dish, keyword...'
    },
    verification: {
      facebook: '31296838546'
    },
    socialShare: {
      facebook: true,
      twitter: true,
      pinterest: true,
      whatsApp: false,
      reddit: false,
      blogger: false,
      tumblr: false,
      vkontakt: false,
      email: true,
      twitterHandle: '@bbcgoodfood',
      fbAuthorizeCode: '31296838546',
      emailSubjectPrefix: 'Yum!',
      emailBodyPrefix: 'Good Food every day...'
    }
  },
  tracking: {
    ampGtmId: 'GTM-NZDN3N5',
    ampGtmEnv: 'gtm_auth=uCwWhqzMY7jwQ2Z9e3Cdfw&gtm_preview=env-2'
  },
  general: {
    siteTitle: 'BBC Good Food'
  },
  myhub: {
    enabled: true,
    title: 'My Good Food',
    collectionInfo: {
      savedItems: {
        empty: {
          title: "You haven't saved any recipes yet…",
          description: "To start collecting your favourites, click the 'Save Recipe' button on any recipe page",
          btnText: 'View recipe hub',
          btnHref: '/recipes'
        }
      },
      collections: {
        empty: {
          title: "You haven't created any collections yet…",
          description: 'Save and sort your favourite recipes into collections so that you can find the perfect dish in no time'
        }
      },
      ownItems: {
        empty: {
          title: "You haven't created any recipes yet…",
          description: 'Got a great recipe? Why not share it with others by publishing it here on bbcgoodfood.com'
        }
      }
    },
    savedRecipes: {
      searchFilter: {
        enabled: true,
        label: 'Search saved recipes',
        collectionInfo: {
          noMatches: {
            title: 'No matches to your filter',
            description: "To start collecting your favourites, click the 'Save Recipe' button on any recipe page",
            btnText: 'View recipe hub',
            btnHref: '/recipes'
          },
          noMatchesOnPage: {
            title: 'No matches to your filter yet…',
            description: 'Load more recipes below'
          }
        }
      }
    },
    relatedContent: {
      moreLink: {
        enabled: true,
        href: '/recipes',
        text: 'View more recipes'
      },
      title: 'Looking for more inspiration?',
      type: ['sxs-recipe'],
      pinnedItems: [{
        clientId: '216299',
        entity: 'recipe',
        source: 'content-api'
      }, {
        clientId: '216791',
        entity: 'recipe',
        source: 'content-api'
      }, {
        clientId: '339298',
        entity: 'recipe',
        source: 'content-api'
      }],
      showCardLabels: false
    }
  },
  enableAmpOnPostType: {
    post: true,
    editorialList: true,
    recipe: true
  }
};
exports["default"] = _default;